export default __webpack_public_path__ + "assets/images/9bc445b9364d1a6aa1b61b7f1c53e092.svg";